module.exports = __webpack_public_path__ + "static/media/YF86_02.034d28df.jpg";